import { userDB } from '@taleemabad/db';
import { useLiveQuery } from 'dexie-react-hooks';
import { IFeatures, IUserRolesAndPermissions } from 'libs/db/src/types/user';
import { PropsWithChildren, createContext, useMemo } from 'react';

export interface ActiveRolePermissionContextProps {
  activeRolePermission: IUserRolesAndPermissions | null;
  features: IFeatures[];
}

export const ActiveRolePermissionContext =
  createContext<ActiveRolePermissionContextProps>({
    activeRolePermission: null,
    features: [],
  });

export const RolesPermissionProvider = ({ children }: PropsWithChildren) => {
  const activeRolePermission = useActiveRolePermission();
  const features = useLiveQuery(() => userDB.getProfileFeatures(), []) ?? [];
  const memoizedValue = useMemo(
    () => ({ activeRolePermission, features }),
    [activeRolePermission, features],
  ) as ActiveRolePermissionContextProps;
  return (
    <ActiveRolePermissionContext.Provider value={memoizedValue}>
      {children}
    </ActiveRolePermissionContext.Provider>
  );
};

export function useActiveRolePermission(): IUserRolesAndPermissions | null {
  const livePermission = useLiveQuery(() => userDB.getActiveRolesPermissions());

  if (!livePermission) {
    return null;
  }

  return livePermission;
}
